var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "cloud-dialog-mask",
          class: _vm.oneHikIdLoading ? "cloud-dialog-mask-full" : "",
        },
        [
          _c(
            "div",
            { staticClass: "cloud-dialog", style: _vm.computeStyle },
            [_vm._t("default")],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }